/**
 * Shared display helpers for SaaSPro PA agent recommendations.
 * Used by both the per-line overlay (paFiling) and the admin decisions table.
 */

export const SAASPRO_RECOMMENDATION_COLORS = {
  approve: 'green',
  partial_approve: 'gold',
  query: 'blue',
  reject: 'red',
};

export const SAASPRO_RECOMMENDATION_LABELS = {
  approve: 'Approve',
  partial_approve: 'Partial approve',
  query: 'Query',
  reject: 'Reject',
};

export const SAASPRO_OUTBOX_STATUS_COLORS = {
  pending: 'default',
  sent: 'green',
  failed: 'red',
  shadow: 'blue',
};

export const SAASPRO_DECISION_STATUS_COLORS = {
  advisory: 'cyan',
  applied: 'green',
  superseded: 'default',
  rejected_by_human: 'red',
};

export const formatCurrencyAmount = (value, fallback = '--') => {
  if (value == null || value === '') return fallback;
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  try {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      maximumFractionDigits: 2,
    }).format(n);
  } catch (e) {
    return `\u20a6${n.toLocaleString('en-NG')}`;
  }
};

export const formatConfidence = (value) => {
  if (value == null) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  if (n <= 1) return `${Math.round(n * 100)}%`;
  return `${Math.round(n)}%`;
};

export const isLowConfidence = (value) => {
  if (value == null) return false;
  const n = Number(value);
  if (!Number.isFinite(n)) return false;
  return n < 0.6 || (n > 1 && n < 60);
};

export const recommendationLabel = (rec) => {
  if (!rec) return '--';
  return SAASPRO_RECOMMENDATION_LABELS[rec] || String(rec).replace(/_/g, ' ');
};

export const recommendationColor = (rec) => {
  return SAASPRO_RECOMMENDATION_COLORS[rec] || 'default';
};

export const truncateMiddle = (value, head = 6, tail = 4) => {
  if (!value) return '';
  const str = String(value);
  if (str.length <= head + tail + 1) return str;
  return `${str.slice(0, head)}\u2026${str.slice(-tail)}`;
};

export const formatTimeAgo = (iso) => {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return '';
  const diff = Date.now() - t;
  if (diff < 0) return 'just now';
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? '' : 's'} ago`;
};
